import Script from 'next/script';
import React from 'react';

const FIDES_HOST = 'https://cmp.onepeloton.com/fides.js';
const FIDES_PROPERTY_ID = 'FDS-UC6FD8';

export const FidesScript: React.FC = () => (
  <>
    <Script
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `
          var fidesSrc = '${FIDES_HOST}' + '?property_id=' + '${FIDES_PROPERTY_ID}' + '&';
          function insertFidesScript() {
            var fidesPrefix = "fides_";
            var searchParams = new URLSearchParams(location.search);
            var fidesSearchParams = new URLSearchParams();
            searchParams.forEach(function (value, key) {
              if (key.startsWith(fidesPrefix)) {
                fidesSearchParams.set(
                  key.replace(fidesPrefix, ""),
                  key === fidesPrefix + "cache_bust" ? Date.now().toString() : value
                );
              }
            });

            var src = fidesSrc + fidesSearchParams.toString();
            var script = document.createElement("script");
            script.async = false;
            script.defer = false;
            script.setAttribute("src", src);
            script.setAttribute("id", "fides-js");
            script.setAttribute("type", "text/javascript");
            let retryCount = 0;
            const maxRetries = 20;
            const waitForAnalytics = setInterval(() => {
              if (window.analytics) {
                document.head.appendChild(script);
                clearInterval(waitForAnalytics);
              } else if (++retryCount >= maxRetries) {
                clearInterval(waitForAnalytics);
              }
            }, 1000);
          }
          window.addEventListener('FidesReady', evt => {
            var id = window.Fides?.experience?.experience_config?.id;
            if (id) {
                window.document.body.classList.add(id);
            }
          });
          window.addEventListener("FidesInitializing", function () { Fides.gtm(); });
          window.insertFidesScript();
        `,
      }}
    />
  </>
);
